if(!window.location.pathname.includes('/pages/access-denied')) {
  let rejectLanguage = ["zh-CN"]
  // let rejectTimeZone = ["GMT-8"]
  // 'Asia/Dhaka'
  let rejectTimeZone = ["Asia/Shanghai"]

  let language = window.navigator.language || window.navigator.browserLanguage;
  let timeZone = (Intl != null) ? Intl.DateTimeFormat().resolvedOptions().timeZone : '';


  console.log('Current Laguage===> ', language)
  console.log('Current TimeZone===> ', timeZone)
  if (rejectLanguage.some(blockedLang => language.startsWith(blockedLang)) && rejectTimeZone.some(blockedZone => timeZone.includes(blockedZone))) {
    let page_params = window.location.search.split('?')[1]?.split('&') || [];
    let page_params_obj = {};
    page_params.forEach(item => {
      let [key, val] = item.split('=')
      page_params_obj[key] = val;
    })
    console.log('Page Params===> ', page_params_obj)
    if(!page_params_obj['timezone_area_limit'] || page_params_obj['timezone_area_limit'] != 'true') {
      console.log('TIMEZONE_AREA_LIMIT')
      window.location.href = "https://jp.chuwi.com/pages/access-denied";
    }  
  }
}